import { takeEvery, takeLatest, all, fork } from 'redux-saga/effects';
import * as actionTypes from './../constants/ActionTypes';
import { loginSaga } from './LoginSaga';
import {
	userFetchSaga,
	userSaveSaga
} from './UserSaga';
import {
	organizationFetchSaga, 
	organizationSaveSaga
} from './OrganizationSaga';
import { partnerFetchSaga,
	partnerSaveSaga,
	fetchPartnerUsers
} from './PartnerSaga';
import {
	tokenVerifySaga
} from './TokenVerifySaga';
import {
	eventFetchSaga,
	eventsFetchSaga,
	partnerPortalSettingsFetchSaga
} from './EventSaga';

import {
	fetchProductSaga,
	fetchProductsSaga,
	fetchProductCategoriesSaga,
	fetchCartSaga,
	addToCartSaga,
	removeProductFromCartSaga,
	setQuantitySaga,
	updateOrderSaga,
	fetchProductBundlesSaga
} from "./ShopSaga";

import {
	fetchOrdersSaga,
	fetchOrderSaga
} from "./OrderSaga";

import {
	checkoutSaga
} from "./CheckoutSaga";

import {
	fetchNotifications
} from './NotificationsSagas';

/* function* watchApp() {
  yield all([takeEvery(actionTypes.LOGIN, loginSaga)]);
  yield all([takeEvery(actionTypes.TOKEN_VERIFY, tokenVerifySaga)]);
  yield all([takeEvery(actionTypes.USER_FETCH, userFetchSaga)]);
  yield all([takeEvery(actionTypes.USER_SAVE, userSaveSaga)]);
  yield all([takeEvery(actionTypes.ORGANIZATION_FETCH, organizationFetchSaga)]);
  yield all([takeEvery(actionTypes.ORGANIZATION_SAVE, organizationSaveSaga)]);
  yield all([takeLatest(actionTypes.EVENT_FETCH, eventFetchSaga)]);
  yield all([takeLatest(actionTypes.PARTNER_FETCH, partnerFetchSaga)]);
  yield all([takeLatest(actionTypes.PARTNER_SAVE, partnerSaveSaga)]);
  yield all([takeEvery(actionTypes.EVENTS_FETCH, eventsFetchSaga)]);
	yield all([takeEvery(actionTypes.PARTNER_PORTAL_SETTINGS_FETCH, partnerPortalSettingsFetchSaga)])
} */

function* watchApp() {
	yield all([
		takeEvery(actionTypes.LOGIN, loginSaga),
		takeEvery(actionTypes.TOKEN_VERIFY, tokenVerifySaga),
		takeEvery(actionTypes.ORGANIZATION_FETCH, organizationFetchSaga),
		takeEvery(actionTypes.ORGANIZATION_SAVE, organizationSaveSaga),
		takeLatest(actionTypes.EVENT_FETCH, eventFetchSaga),
		takeLatest(actionTypes.PARTNER_FETCH, partnerFetchSaga),
		takeLatest(actionTypes.PARTNER_SAVE, partnerSaveSaga),
		takeEvery(actionTypes.EVENTS_FETCH, eventsFetchSaga),
		takeEvery(actionTypes.PARTNER_PORTAL_SETTINGS_FETCH, partnerPortalSettingsFetchSaga),
		takeEvery(actionTypes.FETCH_PARTNER_USERS, fetchPartnerUsers)
	]);
}

function* watchShop() {
  yield all([
		takeEvery(actionTypes.FETCH_PRODUCT, fetchProductSaga),
		takeEvery(actionTypes.FETCH_PRODUCTS, fetchProductsSaga),
		takeEvery(actionTypes.FETCH_PRODUCT_CATEGORIES, fetchProductCategoriesSaga),
		takeEvery(actionTypes.ADD_PRODUCT_TO_CART, addToCartSaga),
		takeEvery(actionTypes.FETCH_CART, fetchCartSaga),
		takeEvery(actionTypes.SET_QUANTITY, setQuantitySaga),
		takeEvery(actionTypes.UPDATE_ORDER, updateOrderSaga),
		takeEvery(actionTypes.SHOP_SORT_BY, fetchProductsSaga),
		takeEvery(actionTypes.REMOVE_PRODUCT_FROM_CART, removeProductFromCartSaga),
		takeEvery(actionTypes.FETCH_PRODUCT_BUNDLES, fetchProductBundlesSaga)
	]);
}

function* watchOrder() {
  yield all([
		takeEvery(actionTypes.FETCH_ORDERS, fetchOrdersSaga),
		takeEvery(actionTypes.FETCH_ORDER, fetchOrderSaga)
	]);
}

export function* watchCheckout() {
  yield all([
   takeEvery(actionTypes.CHECKOUT_REQUEST, checkoutSaga)
 ]);
}

function* watchUsers() {
	yield all([
		takeEvery(actionTypes.USER_FETCH, userFetchSaga),
		takeEvery(actionTypes.USER_SAVE, userSaveSaga)
	]);
}

function* watchNotifications() {
	yield all([
		takeEvery(actionTypes.FETCH_NOTIFICATIONS, fetchNotifications)
	]);
}

export default function* rootSaga() {
  	yield fork(watchApp);
  	yield fork(watchShop);
	yield fork(watchOrder);
	yield fork(watchCheckout);
	yield fork(watchUsers);
	yield fork(watchNotifications);
}
